import AssistantIcon from "@mui/icons-material/Assistant";
import PersonIcon from "@mui/icons-material/Person";
import { Avatar, Paper, Stack, Typography } from "@mui/material";
import { alpha } from "@mui/material/styles";
import React, { useContext } from "react";
import { ChatAvatarContext } from "./ChatAvatarContext";

interface ChatBubbleProps {
  isUser?: boolean;
  senderName?: string;
  children: React.ReactNode;
  paperSx?: object;
  onAnimationEnd?: React.AnimationEventHandler<HTMLElement>;
}

const ChatBubble: React.FC<ChatBubbleProps> = ({ isUser = false, senderName, children, paperSx, onAnimationEnd }) => {
  const avatarUrl = useContext(ChatAvatarContext);
  return (
  <Paper
    component="article"
    aria-label={`${isUser ? "You" : senderName || "Assistant"} message`}
    elevation={2}
    onAnimationEnd={onAnimationEnd}
    sx={{
      alignSelf: isUser ? "flex-end" : "flex-start",
      width: "fit-content",
      maxWidth: isUser ? "90%" : "100%",
      minWidth: 0,
      boxSizing: "border-box",
      p: 1,
      backgroundColor: isUser ? "primary.main" : "background.default",
      backgroundImage: "none",
      color: isUser ? "primary.contrastText" : "text.primary",
      border: (theme) => `1px solid ${isUser ? theme.palette.primary.main : alpha(theme.palette.secondary.main, 0.3)}`,
      overflowWrap: "anywhere",
      "& a": { color: isUser ? "primary.contrastText" : "primary.main" },
      ...paperSx,
    }}
  >
    <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 0.5 }}>
      <Avatar
        src={isUser ? undefined : avatarUrl}
        alt={`${senderName || "Assistant"} avatar`}
        aria-hidden="true"
        sx={{
          bgcolor: isUser ? "primary.dark" : "secondary.main",
          color: isUser ? "primary.contrastText" : "secondary.contrastText",
          width: 24,
          height: 24,
          flexShrink: 0,
          "& svg": { fontSize: 16 },
        }}
      >
        {isUser ? <PersonIcon /> : <AssistantIcon />}
      </Avatar>
      <Typography variant="caption" sx={{ fontWeight: 700, opacity: 0.8, minWidth: 0 }}>
        {isUser ? "You" : senderName || "Assistant"}
      </Typography>
    </Stack>
    {children}
  </Paper>
  );
};

export default ChatBubble;
